import { Link } from "react-router-dom";

export function HelixMark({ className = "h-7 w-7" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M5 2.5 C5 6.5 19 8.5 19 12.5 C19 16.5 5 18.5 5 22.5" />
      <path d="M19 2.5 C19 6.5 5 8.5 5 12.5 C5 16.5 19 18.5 19 22.5" />
      <line x1="7.2" y1="4.6" x2="16.8" y2="4.6" />
      <line x1="8.6" y1="7.6" x2="15.4" y2="7.6" />
      <line x1="8.6" y1="17.4" x2="15.4" y2="17.4" />
      <line x1="7.2" y1="20.4" x2="16.8" y2="20.4" />
    </svg>
  );
}

export function BrandMark({ className = "h-10 w-10" }) {
  return (
    <img
      src="/quadhelix-mark.png"
      alt="QuadHelix Labs"
      className={`${className} object-contain`}
    />
  );
}

export default function Logo({ className = "" }) {
  return (
    <Link
      to="/"
      data-testid="logo-link"
      className={`group flex items-center gap-2.5 ${className}`}
    >
      <img
        src="/quadhelix-mark.png"
        alt="QuadHelix Labs"
        className="h-11 w-11 object-contain transition-transform duration-300 group-hover:scale-105"
      />
      <span className="flex flex-col leading-none">
        <span className="font-heading text-lg font-black tracking-tight text-white">
          QuadHelix <span className="text-cyan">Labs</span>
        </span>
        <span className="font-mono text-[9px] uppercase tracking-[0.34em] text-teal">
          Research Peptides
        </span>
      </span>
    </Link>
  );
}
